import React from "react";
import { Link } from "react-router-dom";

export default function CategoryCard({ category, className = "" }) {
  return (
    <Link
      to={`/shopping/product-list/?category_slug=${category.slug}`}
      className={`group block h-full shrink-0 ${className}`}
    >
      <div className="flex h-full min-w-0 flex-col overflow-hidden rounded-[8px] bg-white shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-md">
        <div className="relative aspect-square overflow-hidden bg-gray-50">
          {category.category_image ? (
            <img
              src={category.category_image}
              alt={category.name}
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-gray-100 px-2 text-center text-xs text-gray-400">
              بدون تصویر
            </div>
          )}
        </div>

        <div className="flex min-h-[3.25rem] flex-1 items-center justify-center px-1 py-1 text-center sm:px-3 sm:py-3">
          <span
            className="line-clamp-2 text-[11px] font-medium leading-4 text-gray-800 transition-colors duration-200 group-hover:text-[#00AFA9] sm:text-sm sm:font-semibold"
            title={category.name}
          >
            {category.name}
          </span>
        </div>
      </div>
    </Link>
  );
}
